"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Insert = _interopRequireDefault(require("../../style/annotations/Insert.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var POINTER_EVENTS_SUPPORTED = !!window.PointerEvent;

var Insert = function Insert(_ref) {
  var annotation = _ref.annotation,
      annotationId = _ref.annotationId,
      commentProposedForDelete = _ref.commentProposedForDelete,
      disableInteraction = _ref.disableInteraction,
      hoveredAnnotation = _ref.hoveredAnnotation,
      isPlacingAnnotation = _ref.isPlacingAnnotation,
      onInsertDown = _ref.onInsertDown,
      onInsertHover = _ref.onInsertHover,
      scaleFactorX = _ref.scaleFactorX,
      scaleFactorY = _ref.scaleFactorY;
  var selector = annotation.target.selector;
  var strokeColor = selector.strokeColor;
  var boundingBox = selector.boundingBox;
  var left = boundingBox[0] * scaleFactorX;
  var top = boundingBox[3] * scaleFactorY;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-html2canvas-ignore": annotationId === 'annotation-placeholder' ? null : true,
    className: (0, _classnames.default)(_Insert.default.component, {
      'temp-Insert': annotationId === 'annotation-placeholder',
      'hovered-text-annotation': hoveredAnnotation === annotationId || commentProposedForDelete && annotationId === commentProposedForDelete.id,
      'ignore-mouse-events': isPlacingAnnotation || disableInteraction
    }),
    "data-annotationid": annotationId,
    "data-annotationtype": "insert",
    style: {
      fill: strokeColor,
      left: "".concat(left, "px"),
      top: "".concat(top, "px")
    },
    onPointerDown: POINTER_EVENTS_SUPPORTED ? onInsertDown : undefined,
    onMouseDown: POINTER_EVENTS_SUPPORTED ? undefined : onInsertDown,
    onTouchStart: POINTER_EVENTS_SUPPORTED ? undefined : onInsertDown,
    onMouseEnter: onInsertHover,
    onMouseLeave: onInsertHover
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "15",
    viewBox: "0 0 34 24"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0,24 L34,24 C22.6051595,22.7481684 16.9384929,14.4434308 17,-0.91421274 C16.9384929,14.4316616 11.2718262,22.7363991 0,24 Z"
  })));
};

Insert.displayName = 'Insert';
Insert.defaultProps = {
  isPlacingAnnotation: false,
  onInsertDown: function onInsertDown() {},
  onInsertHover: function onInsertHover() {},
  scaleFactorX: 1,
  scaleFactorY: 1
};
Insert.propTypes = {
  annotation: _propTypes.default.object,
  annotationId: _propTypes.default.string,
  commentProposedForDelete: _propTypes.default.object,
  disableInteraction: _propTypes.default.bool,
  hoveredAnnotation: _propTypes.default.string,
  isPlacingAnnotation: _propTypes.default.bool,
  onInsertDown: _propTypes.default.func,
  onInsertHover: _propTypes.default.func,
  scaleFactorX: _propTypes.default.number,
  scaleFactorY: _propTypes.default.number
};
var _default = Insert;
exports.default = _default;